import Icon from "./Icon";
export * from "./types";
export default Icon;
